import React, { useEffect } from "react";

import { RideGrid } from "@rimac-seguros/ride-system-components";

import { CardSummary } from "../CardSummary";
import { FormContainer } from "../FormContainer";
import { CardConditions } from "../CardConditions/index";

import "./styles.scss";

export const SectionPayment = ({ title, ...props }) => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <RideGrid className="section-payment">
      <div className="section-payment_title">
        <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
      </div>
      <div className="order-3 col-span-full lg:col-span-7 lg:order-2 xl:col-span-6">
        <FormContainer {...props} />
        <CardConditions />
      </div>
      <div className="order-2 col-span-full lg:col-span-5 lg:order-3 lg:col-start-8">
        <CardSummary />
      </div>
    </RideGrid>
  );
};
